import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useToast } from '@/src/general/components/ToastContext'
import { parseApiError } from '@/src/general/utilities/fetcher/parseApiError'
import { useTranslate } from '@/src/lang/useTranslate'

import { messageApi } from '../api/messageApi'
import { getConversationMessagesOptions } from './useConversationMessagesQuery'

export const useDeleteTextMessageMutation = ({ conversationId }: { conversationId: number }) => {
  const { t } = useTranslate()
  const { addToast } = useToast()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id }: { id: number }) => messageApi.deleteMessage(id),
    // queryClient.invalidateQueries breaks the infinite scroll
    onSuccess: () => queryClient.resetQueries({ queryKey: getConversationMessagesOptions(conversationId).queryKey }),
    onError: (error) => {
      addToast({
        message: t(parseApiError(error, 'messageId') || 'app.error'),
        colors: 'danger',
      })
    },
  })
}
